module.exports = __webpack_public_path__ + "img/forest001.1ac0b91a.jpg";